<!--  -->
<template>
  <div class="main">
    <!-- 标题  -->
    <p class="title-Individual-center">
      <span>人才资源管理</span>
      <i class="el-icon-arrow-right"></i>
      <span class="span-Individual-center">{{ routeName }}</span>
      <i class="el-icon-arrow-right"></i>
      <span class="span-Individual-center">{{ deptTree.deptName }}</span>
      <i class="el-icon-arrow-right" v-if="dept_2"></i>
      <span class="span-Individual-center" v-if="dept_2"
        >{{ dept_2.deptName }}（{{ dept_2.total }}）</span
      >
      <i class="el-icon-arrow-right" v-if="dept_3"></i>
      <span class="span-Individual-center" v-if="dept_3"
        >{{ dept_3.deptName }}（{{ dept_3.total }}）</span
      >
    </p>
    <div class="box">
      <div class="left">
        <div class="flex-box2">
          <div
            class="blue-button"
            style="width: 85px; height: 25px"
            @click="goSet"
          >
            部门设置
          </div>
        </div>
        <div
          class="gs-name overflow-text"
          :title="deptTree && deptTree.deptName ? deptTree.deptName : ''"
          @click="allDep"
          :class="isIndex >= 0 || isDeptId ? '' : 'blue-active'"
        >
          {{ deptTree.deptName }}
        </div>
        <div class="department-list">
          <div
            v-for="(item, index) in deptTree.children"
            :key="index"
            class="department-item firm-clickable"
            @click="open(item, index)"
          >
            <div class="flex-box2 dept-row-head">
              <img
                src="@/assets/imgs/arrow-drop-down-fill@3x.svg"
                alt=""
                v-if="isIndex == index"
              />
              <img
                src="@/assets/imgs/arrow-drop-up-fill@3x.svg"
                alt=""
                v-else
                style="margin-right: 7px;"
              />
              <div
                class="dept-name-l1 overflow-text"
                :title="item.deptName || ''"
                :class="index == isIndex ? 'blue-active' : ''"
              >
                {{ item.deptName }}
              </div>
            </div>
            <div ref="liCol" class="department-content">
              <div
                class="dept-name-l2 overflow-text"
                :title="items.deptName || ''"
                @click.stop="getDetail(items, indexs)"
                v-for="(items, indexs) in item.children"
                :key="indexs"
                :class="isDeptId == items.deptId ? 'blue-active' : ''"
              >
                {{ items.deptName }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="right">
        <div>
          <div class="flex-box2">
            <div
              v-for="(item, index) in list2"
              :key="index"
              :class="item.value == isIndex2 ? 'text-item active' : 'text-item'"
              @click="isIndexChange(item)"
            >
              {{ item.name }}（{{ item.num }}）
            </div>
          </div>
          <div style="margin-top: 30px">
            <el-form
              label-position="left"
              :inline="true"
              :model="ruleForm"
              ref="ruleForm"
              label-suffix="："
              class="demo-ruleForm"
            >
              <el-form-item label="姓名">
                <el-input
                  v-model="ruleForm.name"
                  placeholder="请输入员工姓名"
                  style="width: 150px"
                ></el-input>
              </el-form-item>
              <el-form-item label="身份证号" style="margin: 0 30px">
                <el-input
                  v-model="ruleForm.idNumber"
                  placeholder="请输入身份证号"
                  style="width: 150px"
                ></el-input>
              </el-form-item>
              <el-form-item label="联系方式">
                <el-input
                  v-model="ruleForm.phone"
                  placeholder="请输入联系方式"
                  style="width: 150px"
                ></el-input>
              </el-form-item>
              <el-form-item label="入职时间">
                <el-date-picker
                  v-model="ruleForm.dateTime"
                  type="daterange"
                  value-format="yyyy-MM-dd"
                  range-separator="至"
                  unlink-panels
                  @change="daterangeChange"
                  start-placeholder="请选择"
                  end-placeholder="请选择"
                  style="width: 240px"
                  clearable
                  @clear="ruleForm.dateTime = null"
                >
                </el-date-picker>
              </el-form-item>
              <el-form-item style="margin-left: 40px">
                <el-button
                  type="primary"
                  @click="submitForm('ruleForm')"
                  style="width: 75px"
                  >搜索</el-button
                >
                <el-button @click="resetForm('ruleForm')" style="width: 75px"
                  >重置</el-button
                >
              </el-form-item>
            </el-form>
          </div>
          <div style="float: right">
            <el-button
              type="primary"
              style="margin-bottom: 20px"
              @click="onAdd"
              v-if="isIndex2 == 0"
              >添加</el-button
            >
            <el-button
              type="primary"
              style="margin-bottom: 20px"
              @click="onMove"
              v-if="isIndex2 == 0"
              >批量移动</el-button
            >
            <el-button
              type="primary"
              style="margin-bottom: 20px"
              v-if="isIndex2 == 1"
              @click="onClose('')"
              >批量删除</el-button
            >
          </div>
          <el-table
            ref="multipleTable"
            :data="tableData"
            :row-class-name="tableRowClassName"
            :cell-style="{ 'text-align': 'center', fontSize: '12px' }"
            :header-cell-style="{
              background: '#409eff ',
              color: '#fff',
              'text-align': 'center',
              fontWeight: 300,
              fontSize: '12px',
            }"
            @selection-change="handleSelectionChange"
            row-key="id"
          >
            <el-table-column
              type="selection"
              width="45"
              :reserve-selection="true"
            >
            </el-table-column>
            <el-table-column
              prop="name"
              label="姓名"
              width="120"
              show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column prop="sexName" label="性别" width="50">
            </el-table-column>
            <el-table-column
              prop="age"
              label="年龄"
              width="50"
              show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
              prop="idNumber"
              label="身份证号"
              width="160"
              show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
              prop="phone"
              label="联系方式"
              width="120"
              show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
              prop="deptName"
              label="部门"
             width="120"
              show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
              prop="positionName"
              label="职位"
             width="120"
              show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
              prop="jobStartTime"
              label="入职时间"
              width="120"
              show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
              prop="leaveOrNotName"
              label="状态"
              width="80"
              show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column label="操作" show-overflow-tooltip width="150" fixed="right">
              <div
                style="display: flex; align-items: center"
                slot-scope="scope"
              >
                <el-button
                  type="text"
                  style="color: #fe574a; font-size: 12px"
                  v-if="isIndex2 == 1"
                  @click="onClose(scope.row)"
                  >删除</el-button
                >
                <el-button
                  type="text"
                  style="font-size: 12px"
                  @click="goTalentFile(scope.row)"
                  >资料管理</el-button
                >
                <el-button
                  type="text"
                  @click="onView(scope.row, '编辑')"
                  style="font-size: 12px"
                  v-if="isIndex2 == 0"
                  >编辑</el-button
                >
                <el-button
                  type="text"
                  @click.stop="onView(scope.row, '查看')"
                  style="font-size: 12px"
                  v-if="isIndex2 == 1"
                  >查看</el-button
                >
              </div>
            </el-table-column>
          </el-table>
          <editDrawer
            :drawer="drawer"
            @handleClose="handleClose"
            :deptTree="deptTree"
            :detail="detail"
            ref="editDrawer"
          >
          </editDrawer>
          <!-- 移动弹框 -->
          <dialogModel
            title="批量移动"
            :visible.sync="dialogVisible"
            @handleOk="handleOk"
          >
            <div
              style="
                padding: 30px;
                min-height: 200px;
                display: flex;
                justify-content: center;
              "
            >
              <div class="flex-box2">
                <span>部门：</span>
                <el-cascader
                  placeholder="请选择"
                  :props="{
                    label: 'deptName',
                    value: 'deptId',
                    expandTrigger: 'hover',
                  }"
                  popper-class="mypopperclass"
                  ref="elcascader"
                  :options="deptTree.children"
                  filterable
                  style="margin: 0 auto"
                  @change="deptTreeChange"
                  v-model="deptTreeVal"
                  @click.native="casclick"
                >
                </el-cascader>
              </div>
            </div>
          </dialogModel>
          <!-- 底部分页 -->
          <div class="paging-box">
            <div class="paging">
              <paging
                :pagingObj="pagingObj"
                @handleCurrentChange="handleCurrentChange"
              ></paging>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as API from "@/assets/api/firm/firmTalent.js";
import editDrawer from "./components/editDrawer.vue";
// 引入分页组件
import paging from "../../../../components/paging.vue";
export default {
  components: {
    editDrawer,
    paging,
  },
  data() {
    return {
      //分页数据
      pagingObj: {
        currentPage: 1, //当前页
        pageSize: 10, // 一页显示多少个
        totalDevice: 0, //总数
      },
      routeName: "",
      // 企业信息
      deptTree: "",
      liColHeight: 0, // 折叠面板内容初始高度
      isIndex: -1,
      list2: [
        {
          name: "在职",
          value: 0,
          num: 0,
        },
        {
          name: "离职",
          value: 1,
          num: 0,
        },
      ],
      isIndex2: 0,
      // 员工详情
      detail: "",
      ruleForm: {
        companyId: this.$store.getters.getCompany.id,
        name: "",
        id: "",
        idNumber: "",
        phone: "",
        dateTime: null,
        endTime: "",
        startTime: "",
        leaveOrNot: 0,
        recycleStatus: "",
      },
      tableData: [],
      drawer: false,
      // 删除列表
      closeList: [],
      // 控制移动弹框
      dialogVisible: false,
      // 移动后 部门id
      moveDeptId: "",
      // 原部门id
      oldDeptId: "",
      // 二级部门选中判断
      isDeptId: null,
      // 部门值
      deptTreeVal: [],
      dept_2: "",
      dept_3: "",
    };
  },
  created() {
    this.routeName = this.$route.name;
    this.deptTreeAndCount();
  },
  methods: {
    getContent(item) {
      return `${item.deptName}（${item.total}）`;
    },
    // 查询在职离职员工数量
    getCompanyEmployeeCount() {
      API.getCompanyEmployeeCount({ data: {} }).then((res) => {
        this.list2[0].num = res.data ? res.data.onTheJobCount : 0;
        this.list2[1].num = res.data ? res.data.leaveCount : 0;
      });
    },
    // 公司部门树状结构 带部门人数统计
    deptTreeAndCount() {
      let data = {
        data: {
          companyId: this.$store.getters.getCompany.id,
        },
      };
      API.deptTreeAndCount(data).then((res) => {
        this.deptTree = res.data;
        this.oldDeptId = this.deptTree.deptId;
        this.employeeList();
        this.getCompanyEmployeeCount();
      });
    },
    // 入职时间切换
    daterangeChange(val) {
      if (Array.isArray(val) && val.length === 2 && val[0] && val[1]) {
        this.ruleForm.startTime = val[0];
        this.ruleForm.endTime = val[1];
      } else {
        this.ruleForm.startTime = "";
        this.ruleForm.endTime = "";
      }
    },
    // 搜索
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.employeeList();
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    //重置
    resetForm(formName) {
      this.ruleForm = {
        companyId: this.$store.getters.getCompany.id,
        name: "",
        id: "",
        idNumber: "",
        phone: "",
        dateTime: null,
        endTime: "",
        startTime: "",
        leaveOrNot: this.isIndex2,
        recycleStatus: "",
      };
      this.deptTreeAndCount();
    },
    // 分页
    handleCurrentChange(val) {
      this.pagingObj.currentPage = val;
      this.employeeList(true);
    },
    // 查询员工
    employeeList(isTrue) {
      if (!isTrue) {
        this.$refs.multipleTable.clearSelection();
      }
      let data = {
        pageNo: this.pagingObj.currentPage,
        pageSize: this.pagingObj.pageSize,
        data: this.ruleForm,
      };
      API.employeeList(data).then((res) => {
        this.tableData = res.data.list;
        this.pagingObj.totalDevice = res.data.total;
      });
    },
    // 添加员工
    onAdd() {
      if (!this.$checkAction()) return;
      // 先清空 detail，避免数据残留
      this.detail = null;
      // 先设置 title，再打开 drawer，确保 drawer 的 watch 能正确判断
      this.$refs.editDrawer.title = "添加员工";
      this.$nextTick(() => {
        this.drawer = true;
      });
    },
    // 查看编辑员工
    onView(row, text) {
      // if (!this.$checkAction()) return
      this.$refs.editDrawer.title = text + "员工";
      let data = {
        data: {
          id: row.id,
          companyId: this.$store.getters.getCompany.id,
        },
      };
      API.getEmployee(data).then((res) => {
        // 与 detail 同一 tick 打开 drawer，子组件里 drawerVis 才能先于 detail 回显的 $nextTick 为 true
        this.detail = res.data;
        this.drawer = true;
      });
    },
    handleClose(drawer) {
      this.drawer = drawer;
      this.detail = null;
      this.deptTreeAndCount();
    },
    // 前往部门设置
    // 前往部门设置
    goSet() {
      if (!this.$checkAction()) return;

      // 获取权限
      let permissionCodes = localStorage.getItem("permissionCodes");
      permissionCodes = permissionCodes ? JSON.parse(permissionCodes) : [];

      // 判断是否有部门管理权限
      if (!permissionCodes.includes("company:dept:manage")) {
        this.$message.warning("权限不足，无法执行操作");
        return;
      }

      // 有权限正常跳转
      this.$router.push({
        path: "/Firm/talentStaff/setting",
      });
    },

    deptTreeChange(val) {
      this.moveDeptId = val[val.length - 1];
    },
    // 移动
    onMove() {
      if (!this.$checkAction()) return;
      let that = this;
      if (this.closeList.length > 0) {
        this.deptTreeVal = [];
        this.dialogVisible = true;
      } else {
        that.$tool.PromptBox("error", "请至少勾选一条数据后进行操作！");
      }
    },
    handleOk() {
      let data = {
        data: {
          ids: this.closeList,
          companyId: this.$store.getters.getCompany.id,
          moveDeptId: this.moveDeptId,
          oldDeptId: this.oldDeptId,
        },
      };
      API.batchMove(data).then((res) => {
        if (res.code == 0) {
          this.$tool.PromptBox("success", "操作成功");
          this.dialogVisible = false;
          this.deptTreeAndCount();
        }
      });
    },
    // 删除员工
    onClose(val) {
      if (!this.$checkAction()) return;
      let that = this;
      if (val) {
        this.$confirmWithScroll("是否删除该员工?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          that.batchTrash([val.id]);
        });
      } else {
        if (this.closeList.length > 0) {
          this.$confirmWithScroll("是否删除勾选的员工?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          }).then(() => {
            that.batchTrash(this.closeList);
          });
        } else {
          that.$tool.PromptBox("error", "请至少勾选一条数据后进行操作！");
        }
      }
    },
    // 删除
    batchTrash(ids) {
      let data = {
        data: {
          ids: ids,
          companyId: this.$store.getters.getCompany.id,
          updateTime: "",
        },
      };
      API.batchTrash(data).then((res) => {
        if (res.code == 0) {
          if (res.data.fail > 0) {
            this.$tool.PromptBox("error", res.data.reason);
          } else {
            this.$tool.PromptBox("success", "操作成功");
            this.deptTreeAndCount();
          }
        }
      });
    },
    // 获取全部员工
    allDep() {
      this.dept_2 = "";
      this.dept_3 = "";
      this.$refs.liCol.forEach((item, index) => {
        item.style.height = 0;
      });
      this.isIndex = -1;
      this.isDeptId = "";
      this.ruleForm.id = "";
      this.employeeList();
      this.oldDeptId = this.deptTree.deptId;
    },
    // 点击部门
    getDetail(value, indexs) {
      console.log(value);
      this.dept_3 = value;
      this.isDeptId = value.deptId;
      this.ruleForm.id = value.deptId;
      this.oldDeptId = value.deptId;
      this.employeeList();
    },
    // 展开 / 再次点击收起
    open(item, i) {
      const liCols = this.$refs.liCol || [];

      // 再次点击当前已展开项：收起并恢复为公司级列表
      if (this.isIndex === i) {
        liCols.forEach((col) => {
          col.style.height = this.liColHeight + "px";
        });
        this.isIndex = -1;
        this.dept_2 = "";
        this.dept_3 = "";
        this.isDeptId = "";
        this.ruleForm.id = "";
        this.oldDeptId = this.deptTree.deptId;
        this.employeeList();
        return;
      }

      this.dept_2 = item;
      this.dept_3 = "";
      this.isIndex = i;

      if (item.children && item.children.length) {
        const liCol = liCols[i];
        if (liCol) {
          liCol.style.height = "auto";
          let height = liCol.offsetHeight;
          liCol.style.height = this.liColHeight + "px";
          void document.body.offsetHeight;
          liCol.style.height = height + "px";
        }
        this.isDeptId = item.deptId;
        this.ruleForm.id = item.deptId;
        this.oldDeptId = item.deptId;
      } else {
        this.isDeptId = "";
        this.ruleForm.id = item.deptId;
        this.oldDeptId = item.deptId;
      }

      liCols.forEach((col, index) => {
        if (index !== i) {
          col.style.height = this.liColHeight + "px";
        }
      });
      this.employeeList();
    },
    // 部门一级可以选择
    casclick(event) {
      let that = this;
      this.$nextTick(() => {
        let d = document.getElementsByClassName("mypopperclass");
        if (d[0] && !d[0].onclick) {
          d[0].onclick = function (e) {
            if (e.target.className == "el-cascader-node__label") {
              e.target.previousElementSibling.click();
              that.$refs.elcascader.dropDownVisible = false;
            }
          };
        }
      });
    },
    // 表格选中
    handleSelectionChange(val) {
      this.closeList = val.map((item) => item.id);
    },
    // 在职离职切换
    isIndexChange(item) {
      this.isIndex2 = item.value;
      this.ruleForm.leaveOrNot = item.value;
      this.employeeList();
    },
    // 前往资料管理
    goTalentFile(row) {
      if (!this.$checkAction()) return;
      this.$router.push({
        path: "/Firm/talentFile/detail",
        query: {
          typeValue: this.isIndex2, // 在职/离职
          currentPage: this.pagingObj.currentPage, // 页码
          companyId: this.$store.getters.getCompany.id, // 企业id
          employeeId: row.id, //员工id
          leaveOrNot: this.isIndex2, //在职/离职
        },
      });
    },
    //斑马线
    tableRowClassName({ row, rowIndex }) {
      if (rowIndex % 2 === 0) {
        return "row-style";
      }
      return "";
    },
  },
};
</script>
<style lang="less" scoped>
/* 主内容区滚动条样式 */
::v-deep .el-table__body-wrapper::-webkit-scrollbar {
  height: 8px; /* 主内容区水平滚动条高度 */
}
::v-deep .el-table__fixed-right {
  height: 100% !important; /* 覆盖默认高度计算 */
}
::v-deep .el-table__body-wrapper::-webkit-scrollbar-thumb {
  background: #c0c0c0; /* 灰色滑块，比轨道深一些 */
  border-radius: 4px; /* 可选：滑块圆角 */
}
::v-deep .el-table__body-wrapper {
  scrollbar-width: thin; /* Firefox 中"thin"约 8px 粗细 */
  scrollbar-color: #c0c0c0 #f5f5f5; /* 滑块色 + 轨道色 */
}
/deep/ .el-table .row-style {
  background: #eee;
}

/deep/.el-input__inner {
  height: 35px;
}

/deep/.el-form-item__label {
  padding: 0;
}

/deep/.el-form-item {
  margin-bottom: 30px;
}

/deep/.el-range-editor .el-input__inner {
  padding: 0 10px;
}

.box {
  width: 1200px;
  min-height: 700px;
  box-sizing: border-box;
  margin-top: 20px;
  background: #ffffff;
  box-shadow: 0px 0px 10px 0px rgba(125, 125, 125, 0.5);
  border-radius: 20px;
  padding: 10px 10px;
  display: flex;

  .left {
    width: 180px;
    background: #eeeeee;
    border-radius: 10px;
    padding: 20px 10px;
    box-sizing: border-box;

    .gs-name {
      height: 40px;
      line-height: 40px;
      background: #ffffff;
      border-radius: 10px;
      font-size: 12px;
      text-align: center;
      margin-top: 20px;
      cursor: pointer;
      width: 100%;
      max-width: 100%;
      box-sizing: border-box;
      padding: 0 8px;
    }

    .department-list {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: center;

      .department-item {
        width: 100%;
        font-size: 12px;
        color: #333;
        margin-top: 20px;
        cursor: pointer;

        .dept-row-head {
          padding: 0 10px;
          overflow: hidden;
          flex-wrap: nowrap;
          width: 100%;
          box-sizing: border-box;
        }

        .dept-name-l1 {
          margin-left: 10px;
          flex: 1;
          min-width: 0;
        }

        .department-content {
          width: 100px;
          float: right;
          height: 0px;
          margin-top: 15px;
          overflow: hidden;
          transition: height 0.3s;

          .dept-name-l2 {
            color: #666;
            padding: 10px;
            box-sizing: border-box;
            width: 100%;
            max-width: 100%;
          }
        }
      }
    }
  }

  .right {
    width: calc(100% - 200px);
    padding: 20px;
    margin-left: 10px;
    box-sizing: border-box;

    .text-item {
      background-color: #eee;
      width: 110px;
      font-size: 12px;
      padding: 10px 5px;
      text-align: center;
      margin-right: 20px;
      border-radius: 5px;
      cursor: pointer;
      box-sizing: border-box;
    }

    .active {
      background-color: rgba(97, 144, 232, 0.2);
      color: #409eff ;
    }
  }
}

.blue-active {
  color: #409eff  !important;
}

// 分页
.paging-box {
  width: 100%;
  height: 22px;
  margin-top: 20px;
  display: flex;
  justify-content: flex-end;

  .paging {
    width: 90%;
    height: 100%;
    display: flex;
    justify-content: flex-end;
  }
}
</style>
